import { useEffect, useState } from "react";
import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { Sheet } from "@/components/ax/Sheet";
import { useI18n } from "@/i18n";
import { cutWord, sheetTitle } from "@/lib/sheetStore";

export const PromoteSheet = ({ s, onDone }) => {
  const { t } = useI18n();
  const [question, setQuestion] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (!s.promoteOpen) return;
    const q = s.raised?.text ?? "";
    setQuestion(q);
    setTitle(s.sheet?.title?.trim() || cutWord(q || sheetTitle(s.sheet ?? { title: "", blocks: [] }), 48));
  }, [s.promoteOpen, s.raised, s.sheet]);

  const submit = async () => {
    const decisionId = await s.promote({ questionId: s.raised?.id, question, title });
    if (decisionId) onDone(decisionId);
  };

  return (
    <Sheet
      open={s.promoteOpen}
      onOpenChange={(o) => !o && s.setPromoteOpen(false)}
      title={t("sheet.promote")}
      testId="promote-sheet"
    >
      <p className="m-0 text-sm leading-5 text-ax-text-2">{t("sheet.promoteNote")}</p>
      <Field
        label={t("sheet.question")}
        multiline
        rows={3}
        value={question}
        maxLength={400}
        onChange={(e) => setQuestion(e.target.value)}
        error={s.errors.question}
        testId="promote-question-input"
        className="mt-4"
      />
      <Field
        label={t("sheet.draftTitle")}
        value={title}
        maxLength={80}
        onChange={(e) => setTitle(e.target.value)}
        error={s.errors.draftTitle}
        testId="promote-title-input"
        className="mt-4"
      />
      {s.errors.form && (
        <p role="alert" data-testid="promote-error" className="m-0 mt-3 text-sm leading-5 text-ax-error">
          {s.errors.form}
        </p>
      )}
      <Button
        variant="primary"
        busy={s.busy === "promote"}
        disabled={s.busy === "promote"}
        onClick={submit}
        data-testid="promote-submit-button"
        className="mt-4 w-full"
      >
        {t("sheet.promoteCta")}
      </Button>
      <Button onClick={() => s.setPromoteOpen(false)} data-testid="promote-cancel-button" className="mt-2 w-full">
        {t("sheet.cancel")}
      </Button>
    </Sheet>
  );
};
